module.exports = __webpack_public_path__ + "img/success2@2x.676aa348.png";